import { post } from './API';

export default {
  getInvoicePreview: (keesId, selectedItems) => post(`/api/invoice/preview/${keesId}`, selectedItems),
};
